import { render, staticRenderFns } from "./TransferHelp.vue?vue&type=template&id=adfe9452&scoped=true&"
import script from "./TransferHelp.vue?vue&type=script&lang=js&"
export * from "./TransferHelp.vue?vue&type=script&lang=js&"
import style0 from "./TransferHelp.vue?vue&type=style&index=0&id=adfe9452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfe9452",
  null
  
)

export default component.exports